import { commonOptions } from '@/config/options'
import type { PageContext } from '@zto/zpage'
import dayjs from 'dayjs'

// 新增、编辑商品
export const addEditDialog = (isEdit: Boolean) => {
  return {
    width: 700,
    labelWidth: 100,
    itemSpan: 24,

    onShow: async ({ app, data }: PageContext) => {
      if (!isEdit) {
        return { payload: {} }
      }
      const res = await app.request({
        api: '/cabinet/admin/pms/AdminPmsProductQueryController/detail',
        params: { productCode: data.productCode }
      })

      return {
        payload: {
          ...res,
          videoUrls: res.videoUrl ? [res.videoUrl] : []
        }
      }
    },

    formItems: [
      {
        type: 'dis-input',
        prop: 'productCode',
        label: '商品编号',
        visibleOn: `${isEdit}` // 编辑时 显示
      },

      { type: 'input', prop: 'productName', label: '商品名称', maxlength: 50, trim: true, required: true },
      {
        type: 'fuzzy-select',
        api: '/cabinet/admin/base/AdminBaseSupplierQueryController/queryList',
        apiParams: {
          current: 1,
          size: 500
        },
        prop: 'supplierCode',
        labelProp: 'supplierName',
        label: '供应商',
        optionValueProp: 'supplierCode',
        optionLabelProp: 'supplierName',
        triggerFocus: true,
        remote: false,
        placeholder: '请选择供应商',
        disabled: isEdit,
        required: true,
        span: 12
      },
      { type: 'input', prop: 'productSpec', label: '规格', maxlength: 20, trim: true, required: true, span: 12 },
      {
        type: 'input-number',
        prop: 'costPrice',
        label: '成本价（元）',
        min: 0.01,
        max: 99999.99,
        precision: 2,
        required: true,
        span: 8
      },
      {
        type: 'input-number',
        prop: 'salePrice',
        label: '销售价（元）',
        min: 0.01,
        max: 99999.99,
        precision: 2,
        required: true,
        span: 8
      },
      {
        type: 'input-number',
        prop: 'linePrice',
        label: '划线价（元）',
        min: 0.01,
        max: 99999.99,
        precision: 2,
        required: true,
        span: 8
      },
      {
        label: '商品图片',
        type: 'upload',
        prop: 'imageUrls',
        multiple: true,
        accept: '.jpeg,.jpg,.png,.gif',
        uploadAttrs: {
          dialogTitle: '上传文件',
          tip: '支持jpg、png、jpeg、gif格式，大小10M以内，最多10张',
          sizeLimit: 10
        }, // 限制10M
        listAttrs: { enhance: true },
        countLimit: 10,
        autoHeight: true
      },
      {
        label: '商品视频',
        type: 'upload',
        prop: 'videoUrls',
        multiple: false,
        accept: '.mp4',
        uploadAttrs: { dialogTitle: '上传文件', tip: '支持mp4格式，大小20M以内，最多1条', sizeLimit: 20 }, // 限制20M
        listAttrs: { enhance: true },
        listType: 'video',
        countLimit: 1,
        autoHeight: true
      },
      {
        type: 'textarea',
        prop: 'productSubName',
        label: '商品文案',
        rows: 4,
        resize: 'none',
        maxlength: 100,
        autoHeight: true,
        span: 24
      },
      {
        type: 'textarea',
        prop: 'productDetail',
        label: '商品图文描述',
        rows: 4,
        resize: 'none',
        maxlength: 1000,
        autoHeight: true,
        span: 24
      }
    ],

    beforeSubmit: async ({ app, data }: PageContext, model: any, options: any) => {
      data.mainImageUrl = data?.imageUrls?.[0] || ''
      data.videoUrl = data?.videoUrls?.[0] || ''

      return true
    }
  }
}

export function logDialog() {
  return {
    width: 1000,
    labelWidth: 0,
    itemSpan: 24,

    onShow: async ({ app, data }: PageContext) => {
      const res = await app.request({
        api: 'zscm.kdg.base.OperateLogQueryGateway.queryOperateLog',
        params: { bizNo: data.productCode, logScene: 'product.product_edit', pageIndex: 1, pageSize: 100 }
      })

      return {
        payload: {
          operateLogData: res.data
        }
      }
    },

    formItems: [
      {
        label: '',
        labelWidth: 0,
        type: 'edit-table',
        prop: 'operateLogData',
        span: 24,
        // height: 300,
        noOperation: true,
        autoHeight: true,
        border: true,
        columns: [
          {
            prop: 'gmtCreate',
            label: '操作时间',
            minWidth: 150,
            formatter: (row: any) => {
              return row.gmtCreate ? dayjs(row.gmtCreate).format('YYYY-MM-DD HH:mm:ss') : '--'
            }
          },
          { prop: 'logDesc', label: '操作名称', minWidth: 160 },
          {
            prop: 'bizDataList',
            label: '操作内容',
            minWidth: 400,
            body: ({ data }: PageContext) => {
              const html: any[] = []
              const { bizDataList } = data.row

              bizDataList?.forEach((item: any) => {
                html.push({
                  type: 'html',
                  html: `<div>${item.desc + ' （旧）' + item.oldVal + ' => （新）' + item.newVal}</div>`
                })
              })

              return html
            }
          },
          { prop: 'creator', label: '操作人', minWidth: 100 }
        ]
      }
    ],

    actions: {
      close: {}
    }
  }
}
